// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SeCZB","controls":"styles_controls__3hs-N","charLimit":"styles_charLimit__dws26","input":"styles_input__1Sm6c","send":"styles_send__10W8X"};